// extracted by mini-css-extract-plugin
export default {"container":"K5UQdsAB2as8NC2mk4Cw","description":"jxvpwMtlc59NwU2NcuQg"};